<template>
  <div id="invite-modal">
    <div class="row">
      <div class="col-12">{{$t('invite.modal.title')}}</div>
      <br>
      <div class="col-12 mt-20">
        <div class="share-link">
          {{shareLink}}
        </div>
        <div class="info-text">
          {{$t("invite.modal.infoText")}}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="separator"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 no-gutters">
        <base-input
          :placeHolder="$t('invite.modal.input.placeholder')"
          @enter="addEmail($event)"
          @baseInputValue="emailChanged($event)"
          :text="currentEmail"
          :isInvalid="!isCurrentEmailValid"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-6 text-left email-row" v-for="(email, index) in emails" :key="index">
        <div class="row">
          <div class="col-10">
            <font-awesome-icon class="email-icon" :icon="'envelope'" size="4x" />
            <span>{{email}}</span>
          </div>
          <div class="col-2 text-right">
            <font-awesome-icon
              class="remove-icon text-right"
              :icon="'times'"
              size="4x"
              @click="removeEmail(email)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <base-button @click="invite" :text="$t('invite.modal.buttonText')" class="col-12" />
    </div>
    <div class="row">
      <div class="col-12">
        <span class="cancel" @click="cancel">{{$t('invite.modal.cancelText')}}</span>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';
import BaseInput from '@/components/shared/elements/BaseInput';
import BaseButton from '@/components/shared/elements/BaseButton';

export default {
  name: 'InviteModal',
  components: {
    BaseInput,
    BaseButton,
  },
  props: {},
  data() {
    return {
      currentEmail: '',
      emails: [],
    };
  },
  created() {},
  computed: {
    ...mapGetters({
      loggedInUserProfile: 'users/loggedInUserProfile',
    }),
    isCurrentEmailValid() {
      if (!this.currentEmail || this.currentEmail === '') {
        return true;
      }
      if (this.emails.indexOf(this.currentEmail) >= 0) {
        return false;
      }
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.currentEmail).toLowerCase());
    },
    shareLink() {
      return `https://app.motivac.io/c/${this.loggedInUserProfile.company.invitationCode}`;
    },
  },
  methods: {
    ...mapActions({
      inviteUsers: 'users/inviteUsers',
    }),
    async invite() {
      if (this.currentEmail !== '') {
        this.emails.push(this.currentEmail);
      }
      const result = await this.inviteUsers(this.emails);
      if (result) {
        this.$swal(
          this.$t('invitation.success.title'),
          this.$t('invitation.success.message') + result.emails.join(', '),
          'success',
        );
      } else {
        this.$swal(
          this.$t('invitation.error.title'),
          this.$t('invitation.error.message'),
          'error',
        );
      }
      this.$emit('invitationSent');
      this.$gtag.event('invite', { amount: this.emails.length });
      this.$eventBus.closeModal();
    },
    cancel() {
      this.$eventBus.closeModal();
    },
    addEmail(event) {
      const email = event.target.value;
      if (!email || email === '' || !this.isCurrentEmailValid) {
        return;
      }
      this.emails.push(email);
      this.currentEmail = '';
    },
    removeEmail(email) {
      const index = this.emails.indexOf(email);
      this.emails.splice(index, 1);
    },
    emailChanged(email) {
      this.currentEmail = email;
    },
  },
};
</script>

<style lang="scss" scoped>
#invite-modal {
  min-width: 700px;
  padding: 20px;
  .row {
    margin: 10px 0;
  }
  .cancel {
    cursor: pointer;
    &:hover {
      color: $secondary-color;
    }
  }
  .email-icon,
  .remove-icon {
    max-height: 20px;
    color: #ddd;
    width: unset;
  }
  .remove-icon {
    visibility: hidden;
    cursor: pointer;
  }
  .email-row {
    margin: 10px 0;
    &:hover {
      .remove-icon {
        visibility: visible;
      }
    }
  }
  .share-link {
    color:  rgba(75,86,169,1.0);
    background-color: rgba(75,86,169,.2);
    padding: 10px;
    border-radius: 8px;
  }
  .info-text {
    color: #35363D;
    font-size: 10px;
  }
  .separator {
    border-bottom: 2px dashed #ccc;
    margin: 10px 0;
  }
}
</style>

